import { Button } from "atoms/button/Button";

import { QuizStepProps } from "../useQuestionnaire";

export const Welcome = (props: QuizStepProps) => {
  return (
    <div className="flex h-full flex-col gap-6">
      <p className="bg-gradient-to-r from-[#2B5F6A] to-[#54BAD0] bg-clip-text text-center font-sans text-4xl text-transparent">
        Repeat<strong>Health</strong>
      </p>
      <p className="pt-6 font-serif text-h1">Welcome!</p>
      <p className="font-serif text-h1">
        We need information about your medical history to determine your
        elegibility for this program.
      </p>
      <p className="pt-8">All questions are required.</p>
      <div className="mt-auto">
        <Button fullWidth onClick={props.next}>
          Start Intake Form
        </Button>
      </div>
    </div>
  );
};
